import { Outlet } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import useProjectSync from '../../hooks/useProjectSync';
import useLayoutStore from '../../stores/layoutStore';

export default function AppShell() {
  useProjectSync();

  const railExpanded = useLayoutStore((s) => s.railExpanded);
  const activeCategory = useLayoutStore((s) => s.activeCategory);
  const panelWidth = useLayoutStore((s) => s.panelWidth);

  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' && window.innerWidth < 1024
  );
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const railWidth = railExpanded ? 220 : 64;
  const effectivePanelWidth = activeCategory ? panelWidth : 0;
  const mainMarginLeft = isMobile ? 0 : railWidth + effectivePanelWidth + 16; // +16 für top-2/left-2 Frame-Offset
  const mainPaddingTop = isMobile ? 56 : 0; // Mobile-Header-Höhe

  return (
    <div className="min-h-screen bg-[#F6F6F4]">
      <Sidebar />
      <div
        className="min-h-screen min-w-0 flex flex-col transition-[margin] duration-200 ease-out"
        style={{ marginLeft: mainMarginLeft, paddingTop: mainPaddingTop }}
      >
        <Topbar />
        <main className="flex-1 overflow-y-auto p-7">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
